import { render, staticRenderFns } from "./richText.vue?vue&type=template&id=2dfa518e&scoped=true&"
import script from "./richText.vue?vue&type=script&lang=js&"
export * from "./richText.vue?vue&type=script&lang=js&"
import style1 from "./richText.vue?vue&type=style&index=1&id=2dfa518e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa518e",
  null
  
)

export default component.exports